import { createContext } from 'react';

import { TKycContextValues } from './KycContext.interface';

const defaultValues: TKycContextValues = {
  isLoading: false,
  kycUserInfo: undefined,
  kycUserError: undefined,
  handleInitiateUserKyc: () => {},
};

export const KycContext = createContext<TKycContextValues>(defaultValues);
